import { getAllEstimateAPI } from "./api.js";

export const getAllEstimate = (query, data) => {
  return new Promise((resolve, reject) => {
    getAllEstimateAPI(query, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
